import * as React from "react";

function KeecoIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 84 22"
    >
      <defs>
        <clipPath>
          <rect width="84" height="22" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-keeco)">
        <path
          data-name="Path 7118"
          d="M-27.172,0l-5.436-6.95-1.869,1.429V0h-3.169V-15.136h3.169v6.864l6.821-6.864h3.7l-6.467,6.4L-23.434,0Zm5.414,0V-15.136h11.9v2.449h-8.733v3.8h8.078v2.449h-8.078v3.985h9.174V0ZM-7.084,0V-15.136h11.9v2.449H-3.916v3.8H4.163v2.449H-3.916v3.985H5.258V0ZM14.658-2.277a4.016,4.016,0,0,0,3.985-2.879L21.4-4.114a6.62,6.62,0,0,1-2.616,3.26A7.684,7.684,0,0,1,14.658.215,7.474,7.474,0,0,1,9.013-1.853,7.994,7.994,0,0,1,7.02-7.638a7.93,7.93,0,0,1,1.923-5.726,7.382,7.382,0,0,1,5.575-2,7.952,7.952,0,0,1,4.34,1.069A5.668,5.668,0,0,1,21.21-11.15l-2.793.763a3.259,3.259,0,0,0-1.391-1.81,4.4,4.4,0,0,0-2.444-.671,4,4,0,0,0-3.26,1.332,5.95,5.95,0,0,0-1.112,3.9,6.085,6.085,0,0,0,1.144,3.985A4.053,4.053,0,0,0,14.658-2.277Zm23.536-5.36a8.872,8.872,0,0,1-.935,4.157A6.446,6.446,0,0,1,34.584-.736a8.338,8.338,0,0,1-4.061.951,7.4,7.4,0,0,1-5.591-2.1,7.94,7.94,0,0,1-2.025-5.752,7.728,7.728,0,0,1,2.02-5.683,7.548,7.548,0,0,1,5.618-2.041A7.521,7.521,0,0,1,36.169-13.3,7.732,7.732,0,0,1,38.194-7.638Zm-3.233,0a5.82,5.82,0,0,0-1.16-3.84,4,4,0,0,0-3.255-1.391,4.056,4.056,0,0,0-3.287,1.38A5.811,5.811,0,0,0,26.1-7.638a5.976,5.976,0,0,0,1.187,3.926,3.981,3.981,0,0,0,3.239,1.434,4.018,4.018,0,0,0,3.282-1.4A6.061,6.061,0,0,0,34.96-7.638Z"
          transform="translate(42 19)"
          fill="#314d74"
        />
      </g>
    </svg>
  );
}

export default KeecoIcon;
